
import { ContentData } from '@rtl/api'
import { Options, Prop, Vue } from 'vue-property-decorator'

import ContentCard from '../content/ContentCard.vue'

@Options({
  name: 'UefaContentList',
  components: {
    ContentCard
  }
})
export default class UefaContentList extends Vue {
  @Prop({
    type: Array,
    default: () => []
  })
  readonly contents!: Array<{
    date: Date
    series: string
    items: Array<{
      name: string
      logo: string
      result: number
    }>
    content: ContentData
  }>

  @Prop({
    type: Boolean,
    default: false
  })
  readonly showSlider!: boolean

  @Prop({
    type: Number,
    default: 0
  })
  readonly cols!: number
}
